/*
 *   File : view-modal.js
 *   Author : https://evoqins.com
 *   Description : image view modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";
import Icon from "../icons";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Image View Modal Component ---------- */
export default function ViewModal({
  open = false,
  imageUrl,
  title = "View Image",
  onClose,
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onClose} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0 bg-white-smoke-48"
        style={{
          zIndex: 1055,
          width: "700px",
          maxWidth: "90%",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="d-flex flex-column rg-16 align-items-center p-24">
          <div className="d-flex justify-content-between w-100 align-items-center pb-2">
            <h5 className="fw-500 e-primary-font-rubik fs-16 text-eerie-black mb-0">{title}</h5>
            <PrimaryButton icon="close" className={"btn bg-transparent p-0"} size={14} onPress={onClose}/>
          </div>

          {/* Image */}
          <div className="w-100 text-center bg-white bg-opacity-50 h-100  p-5 d-flex justify-content-center align-items-center rounded-28 ">
            <img
              src={imageUrl}
              alt="Preview"
              className="img-fluid rounded-16 e-drop-view-modal-img"
              style={{
                maxHeight: "400px",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}
